module.exports = __webpack_public_path__ + "img/PMC_2000A_R.1f732da1.png";